import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe, faRocket } from '@fortawesome/free-solid-svg-icons';
import './RocketAnimation.css';

const RocketAnimation = () => {
  const [isLaunched, setIsLaunched] = useState(false);

  const handleLaunch = () => {
    setIsLaunched(!isLaunched);
  };

  return (
    <div className="space">
      {/* Earth Icon */}
      <FontAwesomeIcon icon={faGlobe} className="earth" />

      {/* Orbit container */}
      <div className={`rocket-orbit ${isLaunched ? 'launched' : ''}`}>
        {/* Rocket Icon (rotates around its axis) */}
        <FontAwesomeIcon icon={faRocket} className="rocket" />
      </div>

      <button className="launch-button text-black" onClick={handleLaunch}>
        {isLaunched ? 'Ishan you can stop the Rocket' : 'Ishan Launch SFS Artemes-3'}
      </button>
    </div>
  );
};

export default RocketAnimation;
